<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <h2 v-text="this.editing ? this.titulo : 'Nueva'"></h2>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col>
                    <v-text-field v-model="currentAplicacion.nombre" :rules="[(v) => !!v || 'Nombre es necesario']"
                        label="Nombre" required>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-text-field v-model="currentAplicacion.comentario" label="Comentario" required>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col align="center">
                    <v-btn v-if="this.editing" color="error" class="mr-2" @click="deleteAplicacion">
                        Borrar
                    </v-btn>

                    <v-btn v-if="this.editing" color="success" @click="updateAplicacion">
                        Actualizar
                    </v-btn>

                    <v-btn v-if="!this.editing" color="success" @click="saveAplicacion">
                        Guardar
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="this.editing">
                <v-col>
                    <template>
                        <v-data-table v-if="currentAplicacion.formula_aplicacion" :headers="tabla_formulas"
                            :items="currentAplicacion.formula_aplicacion" class="elevation-1" :items-per-page="-1"
                            hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Formulas para {{ titulo }}</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_formula.cod_formula="{ item }">
                                <router-link :to="'/formulas/' + item.cod_formula.cod_formula">
                                    {{ item.cod_formula.cod_formula }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import AplicacionesDataService from "@/services/AplicacionesDataService";

export default {
    name: "AplicacionId",
    props: ['id'],
    data() {
        return {
            editing: false,
            titulo: "",
            currentAplicacion: {
                id_aplicacion: 0,
                nombre: "",
                comentario: "",
            },
            tabla_formulas: [
                { text: "Codigo", value: "cod_formula.cod_formula" },
                { text: "Descripción", value: "cod_formula.descripcion" },
            ],
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getAplicacion(id) {
            AplicacionesDataService.get(id)
                .then((response) => {
                    this.currentAplicacion = response.data;
                    this.titulo = this.currentAplicacion.nombre;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        updateAplicacion() {
            let data = {
                nombre: this.currentAplicacion.nombre,
                comentario: this.currentAplicacion.comentario,
            };
            AplicacionesDataService.update(this.currentAplicacion.id_aplicacion, data)
                .then((response) => {
                    this.setSnack({ message: "Actualizado correctamente", color: "success" });
                    this.$router.push({ name: "AplicacionesList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        deleteAplicacion() {
            AplicacionesDataService.delete(this.currentAplicacion.id_aplicacion)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.$router.push({ name: "AplicacionesList" });
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        saveAplicacion() {
            let data = {
                nombre: this.currentAplicacion.nombre,
                comentario: this.currentAplicacion.comentario,
            };
            AplicacionesDataService.create(data)
                .then((response) => {
                    this.setSnack({ message: "Creado correctamente", color: "success" });
                    this.$router.push({ name: "AplicacionesList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getAplicacion(this.$route.params.id);
            this.editing = true;
        }
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            this.editing = false;
            this.currentAplicacion = {
                id_aplicacion: 0,
                nombre: "",
                comentario: "",
            };
        }
    }
};
</script>